module.exports = __webpack_public_path__ + "static/media/dmf.250d580d.png";